import { useSearchParams } from "react-router-dom";

import useFCSubscriptionStore from "@hsl/fc-subscription/store";

export const useBackToFC = () => {
    const latestFC = useFCSubscriptionStore((state) => state.latestFC);
    const [params] = useSearchParams();

    const newParams = new URLSearchParams(params);
    newParams.delete("step");

    return latestFC + "?" + newParams.toString();
};
